import { createAction } from 'redux-actions';

const ALERT_MODAL_SHOW = 'ALERT_MODAL_SHOW';
const ALERT_MODAL_HIDE = 'ALERT_MODAL_HIDE';

const showAlertModal = createAction(ALERT_MODAL_SHOW);
const hideAlertModal = createAction(ALERT_MODAL_HIDE);

export default {
  types: {
    ALERT_MODAL_SHOW,
    ALERT_MODAL_HIDE,
  },
  creators: {
    showAlertModal,
    hideAlertModal,
  },
};



// WEBPACK FOOTER //
// ./src/redux/actions/A_Alert_Modal.js